import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Dialog } from 'antd-mobile';
import { LeftOutline } from 'antd-mobile-icons';
import SafeArea from '@/components/SafeArea';
import CustomerEditor from '@/components/CustomerEditor';
import useBackHandler, { BACK_PRIORITY } from '@/hooks/useBackHandler';
import './styles.css';

export default function CustomerForm() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isEdit = Boolean(id);
  const requestedReturnTo = searchParams.get('returnTo');
  const destination = requestedReturnTo?.startsWith('/')
    ? requestedReturnTo
    : isEdit && id
      ? `/customer/${id}`
      : '/customers';
  const [dirty, setDirty] = useState(false);

  const goBack = () => navigate(destination, { replace: true });
  const leaveForm = async () => {
    if (dirty) {
      const confirmed = await Dialog.confirm({
        content: '当前内容尚未保存，确认离开吗？',
        confirmText: '离开'
      });
      if (!confirmed) return;
    }
    goBack();
  };

  useBackHandler(true, leaveForm, BACK_PRIORITY.page);

  return (
    <div className="ios-page customer-form-page">
      <header className="customer-form-header">
        <SafeArea top={false} className="customer-form-safe-area">
          <div className="customer-form-nav">
            <button type="button" onClick={leaveForm} aria-label="取消编辑">
              <LeftOutline aria-hidden="true" />
              <span>取消</span>
            </button>
            <h1>{isEdit ? '编辑客户' : '新增客户'}</h1>
            <span aria-hidden="true" />
          </div>
        </SafeArea>
      </header>

      <CustomerEditor
        customerId={id ? Number(id) : undefined}
        onSaved={goBack}
        onCancel={leaveForm}
        onDirtyChange={setDirty}
      />
    </div>
  );
}
